import React from 'react'
import { DocumentsTable } from 'components/DocumentLibrary/DocumentsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from './CompanyModal'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

interface DocumentsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function DocumentsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: DocumentsModalProps) {
  const TABLE_KEY = forDoorProxyId
    ? `documents-modal-door-${forDoorProxyId}`
    : `documents-modal-company-${contactCompany.id}`

  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Documents"
    >
      <TableLinkStyleProvider variant="plain">
        <div
          className="flex flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]"
          style={{ height: '60vh' }}
        >
          <DocumentsTable
            tableKey={TABLE_KEY}
            filterIdentifier="DOCUMENTS_MODAL"
            tabType="company"
            forChainProxyId={contactCompany.id}
            forDoorProxyId={forDoorProxyId}
            disableUrlPagination
            disableExportButton
          />
        </div>
      </TableLinkStyleProvider>
    </CompanyModal>
  )
}
